import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ClientFilters = ({ filters, onFilterChange, totalClients, filteredCount }) => {
  const handleSearchChange = (e) => {
    onFilterChange?.({ ...filters, searchTerm: e?.target?.value });
  };

  const handleFilterChange = (key, value) => {
    onFilterChange?.({ ...filters, [key]: value });
  };

  const clearFilters = () => {
    onFilterChange?.({
      subscriptionTier: 'all',
      paymentStatus: 'all',
      complianceScore: 'all',
      region: 'all',
      searchTerm: ''
    });
  };

  const hasActiveFilters = 
    filters?.subscriptionTier !== 'all' ||
    filters?.paymentStatus !== 'all' ||
    filters?.complianceScore !== 'all' ||
    filters?.region !== 'all' ||
    filters?.searchTerm !== '';

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-foreground">Filter Clients</h3>
        {hasActiveFilters && (
          <Button
            variant="outline"
            size="sm"
            onClick={clearFilters}
          >
            <Icon name="X" size={14} className="mr-1" />
            Clear Filters
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        {/* Search */}
        <div className="lg:col-span-2">
          <label className="block text-sm font-medium text-foreground mb-2">Search</label>
          <div className="relative">
            <Icon name="Search" size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" />
            <input
              type="text"
              placeholder="Company name, email..."
              value={filters?.searchTerm}
              onChange={handleSearchChange}
              className="w-full pl-10 pr-4 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
            />
          </div>
        </div>

        {/* Subscription Tier */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Subscription Tier</label>
          <select
            value={filters?.subscriptionTier}
            onChange={(e) => handleFilterChange('subscriptionTier', e?.target?.value)}
            className="w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
          >
            <option value="all">All Tiers</option>
            <option value="basic">Basic</option>
            <option value="standard">Standard</option>
            <option value="premium">Premium</option>
            <option value="enterprise">Enterprise</option>
          </select>
        </div>

        {/* Payment Status */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Payment Status</label>
          <select
            value={filters?.paymentStatus}
            onChange={(e) => handleFilterChange('paymentStatus', e?.target?.value)}
            className="w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
          >
            <option value="all">All Status</option>
            <option value="current">Current</option>
            <option value="due_soon">Due Soon</option>
            <option value="overdue">Overdue</option>
          </select>
        </div>

        {/* Compliance Score */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Compliance</label>
          <select
            value={filters?.complianceScore}
            onChange={(e) => handleFilterChange('complianceScore', e?.target?.value)}
            className="w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
          >
            <option value="all">All Scores</option>
            <option value="excellent">90-100% (Excellent)</option>
            <option value="good">70-89% (Good)</option>
            <option value="warning">&lt;70% (Warning)</option>
          </select>
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between">
        <p className="text-sm text-muted-foreground">
          Showing <span className="font-medium text-foreground">{filteredCount}</span> of{' '}
          <span className="font-medium text-foreground">{totalClients}</span> clients
        </p>
      </div>
    </div>
  );
};

export default ClientFilters;